export default __webpack_public_path__ + "static/3-for-mf-mobile-58a524f108963ace9a9c4f70aaa7901b.jpg";